import React, { createContext, useContext } from 'react';
import AppHeader from './AppHeader';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import AppShell from './AppShell';
import MainContentScrollArea from './MainContentScrollArea';

// Create context for sidebar state (kept for future use)
export const SidebarContext = createContext();

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within SidebarProvider');
  }
  return context;
};

const DashboardLayout = () => {
  return (
    <SidebarContext.Provider value={{ sidebarWidth: 0 }}>
      <AppShell>
        {/* Header fixed at top */}
        <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1200 }}>
          <AppHeader />
        </Box>

        <MainContentScrollArea>
          <Outlet />
        </MainContentScrollArea>
      </AppShell>
    </SidebarContext.Provider>
  );
};

export default DashboardLayout;
